// extracted by mini-css-extract-plugin
module.exports = {"logo":"index_logo__7OhKu","serversHeader":"index_serversHeader__kZAXt","authHeader":"index_authHeader__pa6iP"};